module.exports = __webpack_public_path__ + "media/img/map-card-dc92567e.svg";